import React from 'react';
import PropTypes from 'prop-types';

const EditPDFLandingPageBenefitsSection = props => (
  <React.Fragment>
    <div className="large-upload-panel-benefits-list">
      <div className="large-upload-panel-benefits-list-row">
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/pencil-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Erase and add text.
          </p>
        </div>
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/share-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Share in seconds.
          </p>
        </div>
      </div>
      <div className="large-upload-panel-benefits-list-row">
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/sign-arrow-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            E-sign with ease.
          </p>
        </div>
        <div className="large-upload-panel-benefits-list-item">
          <img
            alt="Benefit Icon"
            className="large-upload-panel-benefits-list-item-icon"
            src="/images/printer-icon.png"
          />
          <p
            className="large-upload-panel-benefits-list-item-text"
          >
            Download and print.
          </p>
        </div>
      </div>
    </div>
    <div className="large-upload-panel-testimonial-wrapper">
      <div className="large-upload-panel-testimonial-column">
        <p className="large-upload-panel-testimonial-large-text">1.2 million</p>
        <p className="large-upload-panel-testimonial-small-text">
          customer accounts
        </p>
      </div>
      <div className="large-upload-panel-testimonial-column">
        <p className="large-upload-panel-testimonial-large-text">16 million</p>
        <p className="large-upload-panel-testimonial-small-text">
          documents created
        </p>
      </div>
      <div className="large-upload-panel-testimonial-column press-logo-set">
        {props.isFullWidthUploadPanel ?
          <React.Fragment>
            <img
              alt="Press Icon TNW"
              className="large-upload-panel-testimonial-press-icon tnw-icon"
              src="/images/tnw-icon.png"
            />
            <img
              alt="Press Icon Inc"
              className="large-upload-panel-testimonial-press-icon"
              src="/images/inc-icon.png"
            />
            <img
              alt="Press Icon Readwrite"
              className="large-upload-panel-testimonial-press-icon"
              src="/images/readwrite-icon.png"
            />
            <img
              alt="Press Icon Huffington Post"
              className="large-upload-panel-testimonial-press-icon"
              src="/images/huff-post-icon.png"
            />
          </React.Fragment>
          :
          <img
            alt="Press Icons"
            className="large-upload-panel-testimonial-press-icons"
            src="/images/press-logos-set.png"
          />
        }
      </div>
    </div>
  </React.Fragment>
);

EditPDFLandingPageBenefitsSection.defaultProps = {
  isFullWidthUploadPanel: false,
};

EditPDFLandingPageBenefitsSection.propTypes = {
  isFullWidthUploadPanel: PropTypes.bool,
};

export default EditPDFLandingPageBenefitsSection;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageBenefitsSection.jsx